import React from "react";
import { motion, useReducedMotion } from "framer-motion";
type RevealProps = React.PropsWithChildren<{
  className?: string;
  delay?: number;
}>;
export function Reveal({
  children,
  className,
  delay = 0
}: RevealProps) {
  const reducedMotion = useReducedMotion();
  return <motion.div className={className} initial={reducedMotion ? false : {
    opacity: 0,
    y: 28
  }} whileInView={reducedMotion ? undefined : {
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.18
  }} transition={{
    duration: 0.7,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-159" data-mp="3ggphg41x1e8x">
      {children}
    </motion.div>;
}